const financial = [
  {
    path: '/financial/conditional-returns',
    name: 'financial-conditional-returns',
    component: () => import('@/views/financial/bills/conditionalReturns.vue'),
    meta: {
      layout: 'content', requiresAuth: true, action: 'can_cancel_items_of_payment', resource: 'all',
    },
  },
  {
    path: '/financial/payments',
    name: 'financial-payments',
    component: () => import('@/views/financial/payments.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_payments',
      resource: 'all',
    },
  },
  {
    path: '/financial/payments/:number',
    name: 'financial-payments-number',
    component: () => import('@/views/financial/payments.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_bills',
      resource: 'all',
    },
  },
  {
    path: '/financial/bills',
    name: 'financial-bills',
    component: () => import('@/views/financial/bills/bills.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_bills',
      resource: 'all',
    },
  },
  {
    path: '/financial/bills/:number',
    name: 'financial-bills-number',
    component: () => import('@/views/financial/bills/bills.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_bills',
      resource: 'all',
    },
  },
  {
    path: '/financial/cortex',
    name: 'financial-cortex',
    component: () => import('@/views/financial/cortex.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_cortex_page',
      resource: 'all',
    },
  },
  {
    path: '/financial/sell_report',
    name: 'financial-sell-report',
    component: () => import('@/views/financial/reports/Sell.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_sell_report',
      resource: 'all',
    },
  },
  {
    path: '/financial/replace_code_report',
    name: 'financial-replace-code-report',
    component: () => import('@/views/financial/reports/ReplaceCode.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_replace_report',
      resource: 'all',
    },
  },
  {
    path: '/financial/sell_report_usd',
    name: 'financial-sell-report-usd',
    component: () => import('@/views/financial/reports/SellUSD.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_sell_report_usd',
      resource: 'all',
    },
  },
  {
    path: '/financial/inventory_report',
    name: 'financial-inventory-report',
    component: () => import('@/views/financial/reports/Inventory.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_inventory_report',
      resource: 'all',
    },
  },
  {
    path: '/financial/profit_report',
    name: 'financial-profit-report',
    component: () => import('@/views/financial/reports/Profit.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_profit_report',
      resource: 'all',
    },
  },
  {
    path: '/financial/buyReport',
    name: 'financial-buy-report',
    component: () => import('@/views/financial/reports/BuyReport.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_buy_report',
      resource: 'all',
    },
  },
  {
    path: '/financial/bankwage',
    name: 'financial-bank-wage',
    component: () => import('@/views/financial/bankwage.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_and_change_bank_wage_setting',
      resource: 'all',
    },
  },
]

export default financial
